import { useState } from 'react';
import classnames from "classnames";
import { getBeUrl } from '~/helpers/utilHelper';

type TUserAvatar = {
  id: number;
  image: string;
  initials: string;
  size: string;
  className?: string;
  icon?: string;
}

const UserAvatar = (props: TUserAvatar) => {

  const { id, image, initials, size, className, icon } = props;

  const [isImageError, setIsImageError] = useState(false);

  const imageUrl = getBeUrl(`user/${id}/${image}`);

  const canShowImage = () => !!id && !!image && !isImageError;

  return <div className={classnames('user-avatar', `user-avatar-${size}`, className)}>
    {canShowImage() && <img src={imageUrl} className="user-avatar-img" onError={() => setIsImageError(true)} />}
    {!canShowImage() && <div className="user-avatar-noimg bg-primary bg-soft text-primary">
      {initials && <span className="user-avatar-initials">{initials}</span>}
      {!initials && <i className={classnames('user-avatar-icon', { [icon!]: !!icon, 'fas fa-user': !icon })}></i>}
    </div>}
  </div>
}

export default UserAvatar;